import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { format } from "../../../utils/format";

import styles from "./common.module.scss";

const ShippingCost = (
    props: Immutable<{
        disableShipping?: boolean;
        disableFreeShippingMessage?: boolean;
        costBeforeDiscountExclTax: string | null;
    }>,
): React.ReactNode => {
    if (props.disableShipping) {
        return (
            <>
                {/* TODO(i18n): Translate standalone hyphen as part of complete phrase or use a proper placeholder. Consider format.shippingCost(null) or a localized "TBD" string instead of raw hyphen */}
                <span className="ada-screenreader-only">
                    {t`Uncalculated Shipping`}
                </span>
                -
            </>
        );
    }
    if (
        props.disableFreeShippingMessage &&
        !Number(props.costBeforeDiscountExclTax)
    ) {
        return (
            <>
                {/* TODO(i18n): Translate standalone hyphen as part of complete phrase or use a proper placeholder. Consider format.shippingCost(null) or a localized "TBD" string instead of raw hyphen */}
                <span className="ada-screenreader-only">
                    {t`Uncalculated Shipping`}
                </span>
                -
            </>
        );
    }
    return format.shippingCost(props.costBeforeDiscountExclTax);
};

export const ShippingCostRow = (
    props: Immutable<{
        disableShipping?: boolean;
        disableFreeShippingMessage?: boolean;
        costBeforeDiscountExclTax: string | null;
    }>,
): React.ReactNode => (
    <span className={styles.line}>
        <li>{t`Shipping`}</li>
        <li>
            <ShippingCost {...props} />
        </li>
    </span>
);
